import { positioningConcepts } from "@/mocks/site-data";

export default function PositioningStrip() {
  return (
    <section className="border-y border-secondary-300/40 bg-background-100/80">
      <div className="mx-auto max-w-8xl px-4 md:px-6">
        <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 py-6 md:gap-x-10">
          {positioningConcepts.map((concept, i) => (
            <li key={concept} className="flex items-center gap-x-6 md:gap-x-10">
              <span className="font-heading text-lg font-medium text-foreground-300 md:text-xl">
                {concept}
              </span>
              {i < positioningConcepts.length - 1 && (
                <span className="text-accent-500/70 text-sm" aria-hidden="true">
                  •
                </span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}